import Emitter from "./Emitter";

export default class ExitFullScreen extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EVOLUTION_handler() {
        if (this.gb.evolutionSource) {
            this.gb.evolutionSource.postMessage({
                command: "EVO:EXIT_FULLSCREEN"
            }, "*")
        }
    }

    _default() {
        this.emitGame({ wpgaction: "exitFullScreen" });
    }
}
